const angular = require('angular');

function inputContainerDirective($parse) {
    return {
        restrict: 'E',
        controller: [
            '$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                this.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

                this.element = $element;
                this.messagePanel = $element.find('[ng-messages]').first();
                this.setFocused = function (isFocused) {
                    $element.toggleClass('is-focused', !!isFocused);
                };
                this.setHasValue = function (hasValue) {
                    $element.toggleClass('has-value', !!hasValue);
                };
                this.setInvalid = function (isInvalid) {
                    $element.toggleClass('is-invalid', !!isInvalid);

                    // Set aria attribute to input so error message is read out on focus.
                    if (this.messagePanel.length) {
                        if (isInvalid) {
                            let msgId = this.messagePanel.attr('id');
                            if (!msgId) {
                                msgId = `${this.input.attr('id')}-messages`;
                                this.messagePanel.attr('id', msgId);
                            }

                            this.input.attr('aria-describedby', msgId);
                        } else {
                            this.input.removeAttr('aria-describedby');
                        }
                    }
                };
                $scope.$watch(() => this.label && this.input, (hasLabelAndInput) => {
                    if (hasLabelAndInput && !this.label.attr('for')) {
                        this.label.attr('for', this.input.attr('id'));
                    }
                });
            },
        ],
    };
}

function fakeNgModel() {
    return {
        $fake: true,
        $setViewValue(value) {
            this.$viewValue = value;
            this.$render(value);
            this.$viewChangeListeners.forEach((cb) => { cb(); });
        },
        $isEmpty(value) {
            return (`${value}`).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop,
    };
}

function inputDirective(guid) {
    return {
        restrict: 'E',
        require: ['^?wowInputContainer', '?ngModel', '^?form'],
        link(scope, element, attr, ctrls) {

            const containerCtrl = ctrls[0];
            const ngModelCtrl = ctrls[1] || fakeNgModel();
            const ngForm = ctrls[2] || { $submitted: true };
            const isReadonly = angular.isDefined(attr.readonly);
            if (!containerCtrl) {
                return;
            }
            if (containerCtrl.input) {
                throw new Error('<wow-input-container> can only have *one* <input> child element!');
            }
            containerCtrl.input = element;

            element.addClass('wowInput');
            if (!element.attr('id')) {
                element.attr('id', `input_${guid()}`);
            }

            function ngModelPipelineCheckValue(arg) {
                containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                return arg;
            }

            function inputCheckValue() {
                // An input's value counts if its length > 0,
                // or if the input's validity state says it has bad input (eg string in a number input)
                containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
            }

            const isErrorGetter = containerCtrl.isErrorGetter || function () {
                return ngModelCtrl.$invalid && ngForm.$submitted;
            };
            scope.$watch(isErrorGetter, (isInvalid) => {
                containerCtrl.setInvalid(isInvalid);
                element.attr('aria-invalid', isInvalid);
            });

            ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
            ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

            element.on('input', inputCheckValue);

            if (!isReadonly) {
                element
                    .on('focus', () => {
                        containerCtrl.setFocused(true);
                    })
                    .on('blur', () => {
                        containerCtrl.setFocused(false);
                        inputCheckValue();
                    });
            }

            scope.$on('$destroy', () => {
                containerCtrl.setFocused(false);
                containerCtrl.setHasValue(false);
                containerCtrl.input = null;
            });
        },
    };
}

function labelDirective() {
    return {
        restrict: 'E',
        require: '^?wowInputContainer',
        link(scope, element, attr, containerCtrl) {
            if (!containerCtrl) {
                return;
            }

            containerCtrl.label = element;
            element.addClass('wowLabel');

            scope.$on('$destroy', () => {
                containerCtrl.label = null;
            });
        },
    };
}

function placeholderDirective() {
    return {
        restrict: 'A',
        require: '^^?wowInputContainer',
        link(scope, element, attr, inputContainer) {
            if (!inputContainer || attr.keepPlaceholder) {
                return;
            }
            const placeholderText = attr.placeholder;
            element.removeAttr('placeholder');

            inputContainer.element.find('input').after(`<div class="wowPlaceholder">${placeholderText}</div>`);
        },
    };
}

module.exports = {
    inputContainer: inputContainerDirective,
    input: inputDirective,
    label: labelDirective,
    placeholder: placeholderDirective,
};



// WEBPACK FOOTER //
// ./src/olycommon/input/input.directive.js